import React from "react";
import { useEffect } from "react";
import { useState } from "react";

import { json2csv } from 'json-2-csv';



const Table = ({ headers, rows }) => {

    const [sortedRows, setSortedRows] = useState([])
    const [fieldSortedBy, setFieldSortedBy] = useState('')

    useEffect(() => {
        if (rows) {
            setSortedRows(rows)
        }
    }, [rows])

    const sortBy = (field, index) => {
        const initField = sortedRows.map(r => r.props.children[index].props.children).find(x => !!x)

        const replacement = typeof (initField) === 'string' ? '-' : typeof initField === 'number' ? 0 : typeof initField === 'undefined' ? null : null

        const sortLocal = sortedRows.sort((a, b) => {
            const firstField = a.props.children[index].props.children || replacement
            const secondField = b.props.children[index].props.children || replacement
            if (typeof secondField === 'string' && typeof firstField === 'string') {
                return fieldSortedBy === field ? secondField.toLowerCase().localeCompare(firstField.toLowerCase()) : firstField.toLowerCase().localeCompare(secondField.toLowerCase())
            } else if (typeof firstField === 'number') {
                return fieldSortedBy === field ? secondField - firstField : firstField - secondField
            }
        })

        setFieldSortedBy(fieldSortedBy === field ? '' : field)
        setSortedRows([...sortLocal])
    }


    const drillDown = children => {
        if (typeof children === 'object') {
            if (children && children.props) {
                return drillDown(children.props.children)
            } else if (children && children.length > 0 && children.find(r => r && r.props)) {
                return drillDown(children.map(r => (r && r.props) ? r.props.children : r).flat())
            }
        }
        return children
    }

    const handleExport = async () => {
        const header = headers.props.children.map(header => header.props.children)
        const body = sortedRows.map(row => row.props.children.map(data => data.props.children))


        let jsonData = []
        for (let row of body) {
            let obj = {}, index = 0
            for (let hd of header) {
                obj[hd] = (row[index] && row[index].props) ? drillDown(row[index].props.children) : drillDown(row[index])
                console.log(obj[hd])
                index += 1
            }
            jsonData.push(obj)
        }

        console.log(jsonData)

        const csv = await json2csv(jsonData, {});
        console.log('csv', csv)
        let csvContent = `data:text/csv;charset=utf-8,${csv}`
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "my_data.csv");
        document.body.appendChild(link);
        link.click()
    }

    return <>
        <button onClick={handleExport} style={{ display: 'flex', marginLeft: 'auto', marginBottom: '20px', padding: '10px', borderRadius: '6px', marginTop: 0, marginBottom: '4px' }}>Export</button>
        <table className="tableFixHead">
            <thead>
                {headers.props.children.map((header, index) => <th key={header.props.children} onClick={() => sortBy(header.props.children, index)}>{header.props.children}</th>)}
            </thead>

            <tbody>
                {sortedRows.map((row, idx) => <tr key={row.key + idx}>
                    {row.props.children.map((data, index) => <td key={index} className={data.props.className || ""} style={data.props.style || {}} onClick={() => data.props.onClick ? data.props.onClick() : ''}>{data.props.children}</td>)}
                </tr>)}
            </tbody>
        </table>
    </>
}

export default Table